import React from 'react'
import {Layout} from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
const {Content} = Layout

export default (props) => {
    const {xs} = useBreakpoint();

    return (
       <Content
            style={{
                borderRadius: xs? '4px':'12px',
                overflow: 'initial',
                paddingTop: xs? '24px': '24px',
                paddingLeft: xs? '12px':'36px',
                paddingRight: xs? '12px':'24px',
                minHeight: 1000,
            }}
        >
           {props.children}
       </Content>
    )
}